import { Component, OnInit } from '@angular/core';

import { Platform, NavController } from '@ionic/angular';
//import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { AuthService } from './services/auth.service';
import { EnvService } from 'src/app/services/env.service';
import { BaseService } from 'src/app/xbase/services/base.service';
import { AlertService } from './services/alert.service';
//import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Plugins } from '@capacitor/core';
const { SplashScreen } = Plugins;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
})

export class AppComponent implements OnInit{
  titleContatti:String;
  public appPages = [
    {
      title: 'menu.Profilo',
      url: '/tabs/tabsnavig/profilo',
      icon: 'person-outline'
    },
    {
      title: 'menu.Privacy',
      url: '/tabs/tabsnavig/privacy',
      icon: 'bag-check-outline'
    },
    {
      title: 'menu.Termini',
      url: '/tabs/tabsnavig/termini',
      icon: 'document-lock-outline'
    },
    {
      title: 'menu.Home',
      url: '/tabs/tabsnavig/dashboard',
      icon: 'home'
    },
    {
      title: 'menu.Registry',
      url: '/tabs/tabsnavig/registry',
      icon: 'file-tray-stacked-outline'
    },
    {
      title: 'menu.Utility',
      url: '/tabs/tabsnavig/home',
      icon: 'easel-outline'
    },
    {
      title: 'menu.List',
      url: '/tabs/tabsnavig/list',
      icon: 'list'
    },
    {
      title: 'menu.Contatti',
      url: '/tabs/tabsnavig/contatti',
      icon: 'people'
    },
    {
      title: 'menu.Impostazioni',
      url: '/tabs/tabsnavig/settings',
      icon: 'settings-outline'
    },
    {
      title: 'menu.Info',
      url: '/tabs/tabsnavig/info',
      icon: 'information-outline'
    },
  ];

  constructor(
    private platform: Platform,
    //private splashScreen: SplashScreen,
    private authService: AuthService,
    private env: EnvService,
    private baseService: BaseService,
    private navCtrl: NavController,
    private alertService: AlertService,
    //private keyboard: Keyboard,//PIERO
    ) {
      this.initializeApp();
  }


  ngOnInit(){
    //window.addEventListener("keyup", disableF5);
    //window.addEventListener("keydown", disableF5);
    window.addEventListener("beforeunload", (event) => {
      event.preventDefault();
      console.log("onbeforeunloadx");
      event.returnValue = "Unsaved modifications";
      return event;
   });
   //function disableF5(e:any) {
   //  console.log("which="+e.which+" keyCode="+e.keyCode);
   //   if ((e.which || e.keyCode) == 116) e.preventDefault(); 
   //};
 }


  initializeApp() {
    this.platform.ready().then(() => {
      this.env.setLanguage(this.env.CURRENT_LanguageFamily);//Imposta il linguaggio a NGX-TRANSLATE  
      //this.statusBar.styleLightContent();
      //this.splashScreen.hide();
      SplashScreen.hide();
      //this.authService.getDatiAccesso();
      //this.authService.setVariabiliApp();
      this.authService.getDeviceInfo();
      //this.authService.setStatusBar();
      this.authService.getGeoLocation();
      //console.log("width="+this.platform.width()+"height="+this.platform.height());
    });
  }

  logout() {
    this.authService.logout().subscribe(
      data => {
        this.alertService.presentToast(data['message']);        
      },
      error => {
        console.log(error);
      },
      () => {
        this.navCtrl.navigateRoot('/landing');
      }
    );
  }

  Impostazioni() {
  }
}
